<section data-e2e="confirm-popup" class="ui small modal" [class.language-persistence]="isLocaleSetting">
  <i class="close icon"> <svg   data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.01 30.01"><path d="M16.38 15.01L29.73 1.66A1 1 0 0 0 28.36.29L15.01 13.64 1.66.29A1 1 0 0 0 .29 1.66l13.35 13.35L.29 28.36a1 1 0 0 0 1.37 1.37l13.35-13.35 13.35 13.35a1 1 0 0 0 1.37-1.37z" fill="#757575" fill-rule="evenodd"/></svg> </i>
  <div data-e2e="title" class="d-flex header border-bottom-0-imp" [class.truncate]="title?.length > 255">
    <i *ngIf="icon" class="mt-2 mr-10" phx-icon [phxIcon]="icon?.icon" [size]="20" [color]="icon?.iconColor"></i>
    {{title}}
  </div>

  <div class="content">
    <ng-container *ngIf="!isContentTemplate">
      <p *ngIf="secondaryMessage" class="secondary-message" [innerHtml]="secondaryMessage"></p>
      <p *ngIf="!isLocaleSetting" class="phx-web-type-body-medium phx-web-color-content-standard" [innerHtml]="message"></p>
    </ng-container>
    <ng-container *ngIf="isContentTemplate" [ngTemplateOutlet]="message"></ng-container>

    <p class="message" *ngIf="isLocaleSetting" i18n>
      Your current language is set to {{currentLanguage}}.
      <br>
      Visit <span class="redirect-setting-page" (click)="redirectToAccountSettings()">account settings</span> to change this.
    </p>
  </div>

  <div class="actions clearfix border-top-0-imp">
    <div class="float-left show-again" *ngIf="isLocaleSetting">
      <label class="vertical-center">
        <input class="checkbox" type="checkbox" (change)="dontShowLocaleSettingModalAgain($event)">
        <span class="text" i18n>Don't show again</span>
      </label>
    </div>
    <div class="float-right">      
      <button data-e2e="confirm-cancel" class="mr-12 m-w-100-px cancel" phxHasShadow="true" *ngIf="showCancelButton" phx-button phxSize="mediun" phxHasShadow="true" [phxButtonRole]="makeCancelPrimaryButton ? 'primary' : 'secondary'" phxButtonType="default">
        {{cancelButtonText}}
      </button>
      <button data-e2e="confirm-ok" class="m-w-100-px approve" phx-button phxHasShadow="true" phxSize="mediun" phxHasShadow="true" [phxButtonRole]="makeCancelPrimaryButton ? 'secondary' : 'primary'" [phxButtonType]="isNegativeCTA ? 'negative' : 'default'">
        {{approveButtonText}}
      </button>
    </div>
  </div>
</section>
